export const trainStationMap = [
  { name: 'Ainola', gtfsId: 'HSL:9500297', shortCode: 'AIN' },
  { name: 'Aviapoliksen asema', gtfsId: 'HSL:4000212', shortCode: 'AVP' },
  { name: 'Espoon asema', gtfsId: 'HSL:2000208', shortCode: 'EPO' },
  { name: 'Helsingin rautatieasema', gtfsId: 'HSL:1000201', shortCode: 'HKI' },
  { name: 'Hiekkaharjun asema', gtfsId: 'HSL:4000206', shortCode: 'HKH' },
  { name: 'Huopalahden asema', gtfsId: 'HSL:1000204', shortCode: 'HPL' },
  { name: 'Ilmalan asema', gtfsId: 'HSL:1000203', shortCode: 'ILA' },
  { name: 'Järvenpää', gtfsId: 'HSL:9500298', shortCode: 'JP' },
  { name: 'Jokela', gtfsId: 'HSL:9600201', shortCode: 'JK' },
  { name: 'Jorvaksen asema', gtfsId: 'HSL:6000203', shortCode: 'JRS' },
  { name: 'Kannelmäen asema', gtfsId: 'HSL:1000208', shortCode: 'KAN' },
  { name: 'Käpylän asema', gtfsId: 'HSL:1000209', shortCode: 'KÄP' },
  { name: 'Kauklahden asema', gtfsId: 'HSL:2000209', shortCode: 'KLH' },
  { name: 'Kauniaisten asema', gtfsId: 'HSL:2000205', shortCode: 'KNI' },
  { name: 'Keran asema', gtfsId: 'HSL:2000204', shortCode: 'KEA' },
  { name: 'Keravan asema', gtfsId: 'HSL:9000202', shortCode: 'KE' },
  { name: 'Kilon asema', gtfsId: 'HSL:2000211', shortCode: 'KIL' },
  { name: 'Kirkkonummen asema', gtfsId: 'HSL:6000205', shortCode: 'KKN' },
  { name: 'Kivistön asema', gtfsId: 'HSL:4000211', shortCode: 'KTÖ' },
  { name: 'Koivuhovin asema', gtfsId: 'HSL:2000206', shortCode: 'KVH' },
  { name: 'Koivukylän asema', gtfsId: 'HSL:4000207', shortCode: 'KVY' },
  { name: 'Korson asema', gtfsId: 'HSL:4000209', shortCode: 'KRS' },
  { name: 'Leinelän asema', gtfsId: 'HSL:4000214', shortCode: 'LNÄ' },
  { name: 'Lentoaseman asema', gtfsId: 'HSL:4000213', shortCode: 'LEN' },
  { name: 'Leppävaaran asema', gtfsId: 'HSL:2000202', shortCode: 'LPV' },
  { name: 'Louhelan asema', gtfsId: 'HSL:4000202', shortCode: 'LOH' },
  { name: 'Mäkkylän asema', gtfsId: 'HSL:2000201', shortCode: 'MÄK' },
  { name: 'Malmin asema', gtfsId: 'HSL:1000212', shortCode: 'ML' },
  { name: 'Malminkartanon asema', gtfsId: 'HSL:1000215', shortCode: 'MLO' },
  { name: 'Martinlaakson asema', gtfsId: 'HSL:4000203', shortCode: 'MRL' },
  { name: 'Masalan asema', gtfsId: 'HSL:6000202', shortCode: 'MAS' },
  { name: 'Myyrmäen asema', gtfsId: 'HSL:4000201', shortCode: 'MYR' },
  { name: 'Oulunkylän asema', gtfsId: 'HSL:1000210', shortCode: 'OLK' },
  { name: 'Pasilan asema', gtfsId: 'HSL:1000202', shortCode: 'PSL' },
  { name: 'Pitäjänmäen asema', gtfsId: 'HSL:1000206', shortCode: 'PJM' },
  { name: 'Pohjois-Haagan asema', gtfsId: 'HSL:1000207', shortCode: 'POH' },
  { name: 'Puistolan asema', gtfsId: 'HSL:1000214', shortCode: 'PLA' },
  { name: 'Pukinmäen asema', gtfsId: 'HSL:1000211', shortCode: 'PMK' },
  { name: 'Rekolan asema', gtfsId: 'HSL:4000208', shortCode: 'RKL' },
  { name: 'Saunakallio', gtfsId: 'HSL:9500299', shortCode: 'SAU' },
  { name: 'Savion asema', gtfsId: 'HSL:9000201', shortCode: 'SAV' },
  { name: 'Siuntion asema', gtfsId: 'HSL:6300299', shortCode: 'STI' },
  { name: 'Tapanilan asema', gtfsId: 'HSL:1000213', shortCode: 'TNA' },
  { name: 'Tikkurilan asema', gtfsId: 'HSL:4000205', shortCode: 'TKL' },
  { name: 'Tolsan asema', gtfsId: 'HSL:6000204', shortCode: 'TOL' },
  { name: 'Tuomarilan asema', gtfsId: 'HSL:2000207', shortCode: 'TRL' },
  { name: 'Valimon asema', gtfsId: 'HSL:1000205', shortCode: 'VMO' },
  { name: 'Vantaankosken asema', gtfsId: 'HSL:4000204', shortCode: 'VKS' },
  { name: 'Vehkalan asema', gtfsId: 'HSL:4000210', shortCode: 'VEH' },
];
